import Api from '@/services/Api'

export default {
    all(credentials) {
        return Api().get('tendencia/estado', credentials)
    },
    allSecciones(credentials) {
        return Api().get('tendencia/list-all-secciones', credentials)
    },
}